import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"
import * as contexts from './controllers'

window.Stimulus = Application.start()

for (let context of contexts.default) {
  Stimulus.load(definitionsFromContext(context))
}
